<template>
    <div>
        <h1 class="text-center text-20">{{ $t("views.forgotPassword.title") }}</h1>
        <Alert v-if="data.success" type="success" :message="$t('views.forgotPassword.success')" show-icon class="mb-3"></Alert>
        <Alert v-else-if="data.errorMessage" type="error" :message="data.errorMessage" show-icon class="mb-3"></Alert>
        <template v-if="!data.success">
            <Form :ref="e => (refs.form = e)" layout="vertical">
                <TemplateBuilder :useForm="data.useForm" :fields="data.fields"></TemplateBuilder>
            </Form>
            <div class="d-flex">
                <Button class="ml-auto px-3 btn-primary" @click="() => onClickForgotPassword({ props, data, refs })" :disabled="isLoading">
                    <span>{{ $t("button.forgotPassword") }}</span>
                </Button>
            </div>
        </template>
        <div class="text-right">
            <router-link :to="{ name: 'login' }">{{ $t("button.login") }}</router-link>
        </div>
    </div>
</template>

<script>
import { defineComponent, reactive, defineAsyncComponent } from "vue";
import { isLoading, initForm, onClickForgotPassword } from "./forgot-password.logic";
import { Form, Button, Alert } from "ant-design-vue";

export default defineComponent({
    components: {
        TemplateBuilder: defineAsyncComponent(() => import("../../../components/input/template-builder/TemplateBuilder")),
        Form,
        Button,
        Alert
    },
    setup(props) {
        const data = reactive({ errorMessage: null, buttonForgotPassword: { disabled: false }, success: false });
        const refs = reactive({ form: null });
        initForm({ props, data, refs });
        return { props, data, refs, onClickForgotPassword, isLoading };
    }
});
</script>
